module.exports = __webpack_public_path__ + "img/tiger.6d7db133.svg";